export default {
    name: 'DGOContainer',
    componentName: 'DGOContainer',
    props: {
        baseClass: {
            type: String,
            default: 'dgo-container'
        },
        tag: {
            type: String,
            default: 'div',
        },
        gutter: {
            type: String | Number,
            default: 0,
            validator: (value)=> Number.isInteger(Number(value)) && Number(value) > -1,
        },
    },
    data() {
        return {};
    },
}